import { redirectToApp as redirectToAppBase, type TargetApp } from '@round/creatorbase-helpers';

// This bundle is the creatorbase app; the agency app is served from a separate origin.
export const CURRENT_APP: TargetApp = 'creatorbase';

// Cross-app origins come from env so hosts aren't hardcoded; fall back to production. Env is read
// here (in the app, where Vite guarantees it) rather than in the shared helper.
const APP_URLS: Record<TargetApp, string> = {
    creatorbase: import.meta.env.VITE_CREATORBASE_APP_URL ?? 'https://app.thisisround.com',
    agency: import.meta.env.VITE_AGENCY_APP_URL ?? 'https://agency.thisisround.com',
};

type RedirectOptions = {
    sessionClientId?: number | null;
};

// Hard-navigates to another app. Returns whether it actually navigated (a misconfigured URL pointing
// back at this origin is skipped — see redirectToApp).
export function redirectToApp(app: TargetApp, options?: RedirectOptions): boolean {
    return redirectToAppBase(app, { ...options, appUrls: APP_URLS });
}
